/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class ColorPicker {
        restrict = 'E';
        require = 'ngModel';
        scope = {
            contentKey: "@",
            fallbackValue: "@",
            watchExpression: "@",
            changed: "&?",
            context: "="
        };
        replace = true;
        templateUrl = "app/components/controls/colorPickerTemplate.html";

        constructor() {

        }

        link = (scope: any, element: angular.IAugmentedJQuery, attrs: any, ngModel: angular.INgModelController) => {
            scope.fallbackValue = angular.isDefined(scope.fallbackValue) ? scope.fallbackValue : "";
            var input = <any>element.find('input');
            var options = angular.extend({
                color: ngModel.$viewValue,
                preferredFormat: "hex3",
                showInput: true,
                //clickoutFiresChange: false,
                showButtons: false,
                appendTo: `#meevo-color-picker-${scope.$id}`,

                change: function (color) {
                    scope.applyColor(color);
                },
                move: function (color) {
                    scope.applyColor(color);
                }


            }, scope.$eval(attrs.options));

            ngModel.$render = function () {
                input.spectrum('set', ngModel.$viewValue || scope.fallbackValue);
            };

            scope.applyColor = (color) => {
                scope.$apply(function () {
                    ngModel.$setViewValue(color.toHexString());

                    if (typeof scope.changed === 'function') {
                        scope.changed();
                    }
                });
            }


            input.spectrum(options);
            
            scope.$watch(scope.watchExpression, (value) => {
                input.spectrum('set', ngModel.$viewValue || scope.fallbackValue);
                if (value) {
                    input.spectrum("disable");
                } else {
                    input.spectrum("enable");
                }
            });

        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new ColorPicker();
            };

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("colorPicker", ColorPicker.factory());
}